<template>
  <v-container>
    <v-row justify="center" align="center">
      <v-col cols="12" sm="4">
        <h1
          class="text-center font-weight-medium text-h4 mb-4"
          style="color:#1E88E5"
        >
          Cadastro
        </h1>
        <v-form ref="form" class="mt-6" v-model="valid" lazy-validation>
          <v-text-field
            v-model.trim="name"
            :rules="nameRules"
            placeholder="Nome completo"
            label="Nome completo"
            outlined
            required
            class="font-weight-bold"
          ></v-text-field>
          <v-text-field
            v-model.trim="email"
            :rules="emailRules"
            placeholder="E-mail"
            label="E-mail"
            outlined
            required
            class="font-weight-bold"
          ></v-text-field>
          <!--
          <v-text-field
            v-model.trim="cpf"
            :rules="cpfRules"
            placeholder="CPF"
            label="Documento CPF"
            outlined
            required
            v-mask="'###.###.###-##'"
            class="font-weight-bold"
          ></v-text-field>
          <v-text-field
            v-model.trim="rg"
            :rules="rgRules"
            placeholder="RG"
            label="Documento (RG)"
            outlined
            required
            class="font-weight-bold"
          ></v-text-field>
          -->
          <!--
          <v-text-field
            v-model.trim="naturalidade"
            :rules="naturalidadeRules"
            placeholder="Naturalidade"
            label="Naturalidade"
            :append-icon="'mdi-information-outline'"
            @click:append="showInfo = !showInfo"
            outlined
            required
          ></v-text-field>
          -->
          <v-text-field
            v-model.trim="dataNascimento"
            :rules="dataNascimentoRules"
            placeholder="Nascimento"
            label="Data Nascimento"
            outlined
            required
            v-mask="'##/##/####'"
            class="font-weight-bold"
          ></v-text-field>
          <v-text-field
            v-model.trim="naturalidade"
            :rules="naturalidadeRules"
            placeholder="Cidade nascimento"
            label="Cidade nascimento"
            :append-icon="'mdi-information-outline'"
            @click:append="toast(naturalidadeMessage)"
            outlined
            required
            class="font-weight-bold"
          ></v-text-field>
          <v-text-field
            v-model.trim="cidadeAtual"
            :rules="naturalidadeRules"
            placeholder="Cidade que reside"
            label="Cidade que reside"
            :append-icon="'mdi-information-outline'"
            @click:append="toast(cidadeAtualMessage)"
            outlined
            required
            class="font-weight-bold"
          ></v-text-field>
          <v-text-field
            :type="show1 ? 'text' : 'password'"
            class="mt-2 font-weight-bold"
            :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'"
            v-model.trim="password"
            :rules="passwordRules"
            placeholder="Senha"
            label="Senha"
            @click:append="show1 = !show1"
            outlined
            required
          ></v-text-field>
          <v-row align="center" justify="center" class="mt-4">
            <div class="text-center font-weight-bold">
              TERMO DE CONSENTIMENTO (LGPD)
            </div>
            <p
              v-if="!isCompliance"
              class="mt-4 text-justify font-weight-light px-4"
            >
              Ao clicar em cadastrar, você estará consentindo que os
              desenvolvedores do teste a seguir, coletem, acessem, utilizem e
              arquivem seus dados pessoais para a realização da nossa pesquisa,
              em conformidade com a Lei nº 13.709 – Lei Geral de Proteção de
              Dados Pessoais (LGPD).
            </p>
            <p v-else class="mt-4 text-justify font-weight-light px-4">
              Ao clicar em cadastrar, você consentirá que coletemos e utilizemos
              os seus dados pessoais somente para fins de aplicação relacionadas ao
              teste, manteremos medidas de proteção em conformidade com a Lei nº
              13.709 – Lei Geral de Proteção de Dados Pessoais (LGPD).
            </p>
          </v-row>
          <v-row align="center" justify="center" class="mt-4">
            <v-btn
              block
              :disabled="!valid"
              color="#1E88E5"
              class="white--text font-weight-bold px-4"
              @click="validate"
              >Cadastrar</v-btn
            >
            <v-btn
              block
              color="#1E88E5"
              outlined
              class="mt-4"
              @click="backToLogin"
              >Voltar</v-btn
            >
          </v-row>
        </v-form>
      </v-col>
    </v-row>
    <v-row justify="center">
      <v-dialog v-model="newUserDialog" persistent max-width="290">
        <v-card>
          <v-card-title class="headline">Cadastro</v-card-title>
          <v-card-text>{{ newUserDialogMessage }}</v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn text color="primary" @click="newUserDialog = !newUserDialog"
              >OK</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>
    <div class="text-center">
      <v-bottom-sheet v-model="showInfo">
        <v-sheet class="text-center" height="240">
          <div width="100%" class="py-3 pt-8 px-6">
            <!--
            <span class="px-8"
              >Naturalidade é o município de nascimento. Essa informação pode
              ser encontrada no RG(Registro Geral) ou na certidão de
              nascimento.</span
            >
            -->
            <span class="px-8">{{ toastInfoMessage }}</span>
          </div>
          <v-btn
            class="mt-6 mb-8 white--text"
            color="#1E88E5"
            @click="showInfo = !showInfo"
            >Entendi</v-btn
          >
        </v-sheet>
      </v-bottom-sheet>
    </div>
  </v-container>
</template>

<script>
import { auth, db, firestore } from "../../firebase.js";
import { router } from "../router";
import CPF from "cpf";

export default {
  name: "Signup",
  data: () => ({
    newUserDialog: false,
    newUserDialogMessage: "",
    valid: true,
    show1: false,
    showInfo: false,
    error: false,
    naturalidade: "",
    naturalidadeRules: [(v) => !!v || "Campo é obrigatório"],
    rg: "",
    rgRules: [(v) => !!v || "Campo é obrigatório"],
    name: "",
    nameRules: [(v) => !!v || "Nome é obrigatório"],
    email: "",
    emailRules: [
      (v) => !!v || "E-mail é obrigatório",
      (v) => /.+@.+\..+/.test(v) || "E-mail precisa ser válido",
    ],
    password: "",
    passwordRules: [
      (v) => !!v || "A senha é obrigatória",
      (v) => v.length >= 6 || "A senha precisa ter 6 ou mais caracteres",
    ],
    cidadeAtual: "",
    naturalidadeMessage: `Naturalidade é o município de nascimento. Essa informação pode
      ser encontrada no RG(Registro Geral) ou na certidão de
      nascimento.`,
    cidadeAtualMessage: `Cidade que reside atualmente`,
    cpf: "",
    cpfRules: [
      (v) => !!v || "Campo é obrigatório",
      (v) => CPF.isValid(v) || "CPF precisa ser válido",
    ],
    toastInfoMessage: "",
    dataNascimento: "",
    dataNascimentoRules: [(v) => !!v || "Campo é obrigatório"],
  }),
  computed: {
    isCompliance() {
      return this.$route.query.t && this.$route.query.t === "compliance";
    },
  },
  methods: {
    validate() {
      if (this.$refs.form.validate()) this.signup();
    },
    signup() {
      auth
        .createUserWithEmailAndPassword(this.email, this.password)
        .then((resp) => {
          this.newUserDialogMessage = "A conta foi criada com sucesso!";
          this.newUserDialog = true;

          db.collection("cadastro_coleta_2")
            .doc(resp.user.uid)
            .set({
              user_id: resp.user.uid,
              email: resp.user.email,
              name: this.name,
              //cpf: this.cpf,
              birthdate: this.dataNascimento,
              birthplace: this.naturalidade,
              current_city: this.cidadeAtual,
              //rg: this.rg,
              lgpd_term: true,
              created: firestore.Timestamp.now(),
              user_type:
                this.$route.query.t && this.$route.query.t === "compliance"
                  ? 2
                  : 1,
              completed_test: false,
            });
        })
        .then(() => {
          this.login();
        })
        .catch((error) => {
          this.newUserDialogMessage = this.errorHandler(error);
          this.newUserDialog = true;
        });
    },
    login() {
      this.$store
        .dispatch("login", {
          email: this.email,
          password: this.password,
        })
        .then((success) => {
          router.push({ name: "Home" }).catch((error) => {
          });
        })
        .catch((error) => {
          this.error = true;
        });
    },
    backToLogin() {
      router.push({ name: "Login" });
    },
    errorHandler(error) {
      if (error.code == "auth/email-already-in-use") {
        return "O email já está sendo utilizado. Utilize outro email ou faça login com sua conta.";
      } else {
        return "Não foi possível concluir a solicitação. \
         Por gentileza, tente novamente mais tarde.";
      }
    },
    toast(message) {
      this.showInfo = !this.showInfo;
      this.toastInfoMessage = message;
    },
  },
};
</script>
